import { LOCAL_STORAGE_KEY } from '../core/consts/localStorage.const';

const webLS = window.localStorage ?? {};

export function getRappiServicesBaseURL() {
  return webLS.getItem(LOCAL_STORAGE_KEY.country.services) ?? '';
}
